import MainLayout from '../../containers/MainLayout'
import RulingNumberDetailContainer from '../../containers/RulingNumberDetailContainerV2'
import { withTranslation } from '../../i18n'
import { ETypeNumerologyPage } from '../../services/models'
import {
	IRulingNumberDetailPageProps,
	getServerSideProps
} from '../../ssr/rulingNumberDetail'
import { useRouter } from 'next/router'
import metaData from '../../resource/data/meta-data'
import { ELanguage } from '@microfrontends/react-components'
import { EPages } from '@microfrontends/app-shell-v2'

export function RulingNumberDetail(props: IRulingNumberDetailPageProps) {
	const router = useRouter()
	const rulingNumberId = router.query.rulingNumberId as string
	const rullingNumberMetaData = metaData['rulling-number'].vi[rulingNumberId]
	const {
		isRobot = false,
		famousPeople = [],
		rulingNumberList = [],
		rulingNumberJobs = []
	} = props
	return (
		<MainLayout
			{...props}
			metaCanonical={'so-chu-dao/' + rulingNumberId}
			numerologyPage={ETypeNumerologyPage.DetailNumerology}
			pageName={EPages.NUMEROLOGY}
			languageCode={ELanguage.VI}
			metaTitle={rullingNumberMetaData.title}
			metaDescription={rullingNumberMetaData.description}
			responsiveCornerColor='#005AFF'
		>
			<RulingNumberDetailContainer
				rulingNumberJobs={rulingNumberJobs}
				isRobot={isRobot}
				famousPeople={famousPeople}
				rulingNumberList={rulingNumberList}
			/>
		</MainLayout>
	)
}
export default withTranslation('home')(RulingNumberDetail as any)

export { getServerSideProps }
